<img id="genesys-chat-icon" *ngIf="genesysChatIcon !== null" class="cp"
(click)="loadGenesysChat()" [src]="genesysChatIcon"/>






